
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seria-knig/[alias]",
      function () {
        return require("private-next-pages/seria-knig/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seria-knig/[alias]"])
      });
    }
  